import { fromJS } from 'immutable';
import * as estimateCalcActions from '../actions/interalAdministration';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  nightlyTotals: { data: [], state: null },
  queryExecute: { data: [], state: null },
  propertyLetterFields: { data: [], state: null },
  letterJob: { data: null, state: null },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case estimateCalcActions.FETCH_ADMINISTRATION_NIGHTLY_TOTALS[START]:
      return state.setIn(['nightlyTotals', 'state'], fetchingState.FETCHING);
    case estimateCalcActions.FETCH_ADMINISTRATION_NIGHTLY_TOTALS[SUCCESS]:
      return state
        .setIn(
          ['nightlyTotals', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(['nightlyTotals', 'state'], fetchingState.LOADED);
    case estimateCalcActions.FETCH_ADMINISTRATION_NIGHTLY_TOTALS[ERROR]:
      return state.setIn(['nightlyTotals', 'state'], fetchingState.ERROR);

    case estimateCalcActions.QUERY_EXECUTOR_ADMINISTRATION[START]:
      return state.setIn(['queryExecute', 'state'], fetchingState.FETCHING);
    case estimateCalcActions.QUERY_EXECUTOR_ADMINISTRATION[SUCCESS]:
      return state
        .setIn(
          ['queryExecute', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(['queryExecute', 'state'], fetchingState.LOADED);
    case estimateCalcActions.QUERY_EXECUTOR_ADMINISTRATION[ERROR]:
      return state.setIn(['queryExecute', 'state'], fetchingState.ERROR);

    case estimateCalcActions.FETCH_PROPERTY_LETTER_FIELDS[START]:
      return state.setIn(
        ['propertyLetterFields', 'state'],
        fetchingState.FETCHING,
      );
    case estimateCalcActions.FETCH_PROPERTY_LETTER_FIELDS[SUCCESS]:
      return state
        .setIn(
          ['propertyLetterFields', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(['propertyLetterFields', 'state'], fetchingState.LOADED);
    case estimateCalcActions.FETCH_PROPERTY_LETTER_FIELDS[ERROR]:
      return state.setIn(
        ['propertyLetterFields', 'state'],
        fetchingState.ERROR,
      );

    case 'CREATE_LETTER_JOB_START':
      return state.setIn(['letterJob', 'state'], fetchingState.FETCHING);
    case 'CREATE_LETTER_JOB_SUCCESS':
      return state
        .setIn(['letterJob', 'data'], fromJS(action.data))
        .setIn(['letterJob', 'state'], fetchingState.LOADED);
    case 'CREATE_LETTER_JOB_ERROR':
      return state.setIn(['letterJob', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
